/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { GroupOutlined, LogoutOutlined, MenuOutlined } from "@ant-design/icons";
import { Button, Drawer, Menu } from "antd";

export default function MobileMenu({ logout }) {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
    };
  }
  const items = [
    getItem(<a href="/#/">Surveys</a>, "surveys", <GroupOutlined />),
    getItem(<a onClick={logout}>Logout</a>, "logout", <LogoutOutlined />),
  ];

  return (
    <>
      <Button
        type="primary"
        onClick={showDrawer}
        ghost
        style={{
          marginLeft: 12,
          border: "none",
          boxShadow: "none",
          fontSize: "20px",
          lineHeight: "22px",
        }}
      >
        <MenuOutlined />
      </Button>
      <Drawer
        title="Menu"
        placement="top"
        onClose={onClose}
        open={open}
        width={"100%"}
        height={"450px"}
      >
        <Menu mode="inline" className="Mobile_menu" items={items} />
      </Drawer>
    </>
  );
}
